import api, { cooperplaceApi } from 'services/api';

/**
 * Reutiliza os mesmos cadastros completos dos seletores, sem importar ou alterar cadastros.
 * O motorista vem do veículo escolhido no Kanban (id da pessoa); sem ele, o usuário preenche à mão.
 */
export async function attendancePrefill(record) {
  const { selection } = record;
  if (selection.wagons.length > 3)
    throw new Error('O formulário suporta até três implementos. Revise a composição do candidato.');
  const personId = selection.driver?.id;
  // 5719: só pelo implemento, a Placa principal fica vazia para o usuário informar o cavalo.
  const vehicleId = selection.vehicle?.id ?? null;
  const [vehicleResponse, driverResponse, ...wagons] = await Promise.all([
    vehicleId ? api.get(`/vehicles/${vehicleId}`) : Promise.resolve({ data: null }),
    // limit 1: uma API sem suporte a personId devolve no máximo um motorista, que não casa pelo id.
    personId
      ? api.get('drivers/select', { params: { personId, limit: 1 } })
      : Promise.resolve({ data: [] }),
    ...selection.wagons.map((wagon) => cooperplaceApi.get(`/wagons/${wagon.id}`)),
  ]);
  const main = vehicleResponse.data;
  if (
    (vehicleId ? main?.id !== vehicleId : main !== null) ||
    wagons.some((response, index) => response.data?.id !== selection.wagons[index].id)
  )
    throw new Error('Cadastro do candidato incompleto. Retorne ao Kanban e selecione novamente.');
  const driver = (driverResponse.data || []).find((item) => item.id === personId);
  return {
    ...(driver ? { driver } : {}),
    vehicle: {
      main,
      implement: wagons[0]?.data || null,
      implement2: wagons[1]?.data || null,
      implement3: wagons[2]?.data || null,
    },
    controlTower: record,
  };
}
